import { Component, NodeEventType, _decorator } from 'cc';

const { ccclass } = _decorator;
const eventTypes = [
    NodeEventType.TOUCH_START,
    NodeEventType.TOUCH_END,
    NodeEventType.TOUCH_MOVE,
    NodeEventType.MOUSE_DOWN,
    NodeEventType.MOUSE_MOVE,
    NodeEventType.MOUSE_UP,
    NodeEventType.MOUSE_ENTER,
    NodeEventType.MOUSE_LEAVE,
    NodeEventType.MOUSE_WHEEL,
];

/**
 * attach this component to a node as a child of the target node which you want to enlarge the input event area
 */
@ccclass('EnlargeInputEvent')
export default class EnlargeInputEvent extends Component {
    onEnable() {
        eventTypes.forEach((event) => {
            this.node.on(event, this._allowPropagation, this);
        });
    }

    onDisable() {
        eventTypes.forEach((event) => {
            this.node.off(event, this._allowPropagation, this);
        });
    }

    private _allowPropagation() {
        // do nothing, just allow the event to propagate to the parent node
    }
}
